module.exports = __webpack_public_path__ + "img/4.548f2803.jpg";